import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=dc9bcdc2&scoped=true"
import script from "./Disclaimer.vue?vue&type=script&lang=ts"
export * from "./Disclaimer.vue?vue&type=script&lang=ts"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&id=dc9bcdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9bcdc2",
  null
  
)

export default component.exports